export default __webpack_public_path__ + "static/media/popular1.fee33a3d.png";